var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileTagged = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 21,
  viewBox: "0 0 23 21",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "m12.302.48 2.383 2.041H20.5c1.105 0 2 .895 2 1.998v14.483a2 2 0 0 1-2 1.998H2c-1.105 0-2-.894-2-1.998V4.52c0-1.103.895-1.998 2-1.998h5.315L9.698.481a2 2 0 0 1 2.604 0m-1.953.76L7.685 3.52H2a1 1 0 0 0-1 1v14.482a1 1 0 0 0 1 1h18.5a1 1 0 0 0 1-1V4.52a1 1 0 0 0-1-.999h-6.185l-2.664-2.28a1 1 0 0 0-1.302 0M13.5 13.01c1.105 0 2 .894 2 1.997v.999h-1v-.999a1 1 0 0 0-1-.999h-5a1 1 0 0 0-1 .999v.999h-1v-.999c0-1.103.895-1.998 2-1.998ZM11 7.015c1.38 0 2.5 1.118 2.5 2.497 0 1.38-1.12 2.497-2.5 2.497s-2.5-1.118-2.5-2.497S9.62 7.016 11 7.016m0 1a1.5 1.5 0 1 0-.002 2.997A1.5 1.5 0 0 0 11 8.015"
})));
export default SvgInstagramMobileTagged;